module.exports = __webpack_public_path__ + "media/trailer.ff9db2fc.mp4";